<template>
  <div class="card mb-10">
    <div class="card-header" id="headingTho">
      <div class="changes-travalers theme-account-history table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th>Ticket</th>
              <th>Viajante</th>
              <th>Status</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ticket in flight.tickets" :key="ticket.id">
              <td>
                <i class="fa fa-plane theme-account-history-type-icon"></i>
              </td>
              <td>
                <div>{{ flight.segments[0].airline.name }} | {{ ticket.origin_iata }} ↔ {{ ticket.destination_iata }}</div>
                <div>
                  <small class="theme-account-history-type-icon">De: {{ ticket.origin_iata }}</small>
                </div>
                <div>
                  <small class="theme-account-history-type-icon">Para: {{ ticket.destination_iata }}</small>
                </div>
                <div>
                  <small>
                    Localizador: {{ flight.locator }}
                  </small>
                </div>
                <div v-if="flight.locator_company">
                  <small>
                    Localizador Latam (check-in): {{ flight.locator_company }}
                  </small>
                </div>
                <div>
                  <small>
                  Bilhete: {{ ticket.number }}
                  </small>
                </div>
              </td>
              <td>{{ ticket.traveler.full_name }}</td>
              <td>
                <div>
                  <p>
                    <i class="fa fa-lg"
                      :class="[
                        {'fa-clock-o text-warning': getStatus(item.status) === 'Processando'},
                        {'fa-clock-o text-warning': getStatus(item.status) === 'Reservado'},
                        {'fa-check-circle text-success': getStatus(item.status) === 'Emitido'},
                        {'fa-times-circle text-danger': getStatus(item.status) === 'Cancelado'},
                        {'fa-times-circle text-danger': getStatus(item.status) === 'Pagamento Recusado'},
                        {'fa-clock-o text-warning': getStatus(item.status) === 'Aguardando Aprovação'}
                      ]"></i>&nbsp;{{ getStatus(item.status) }}
                  </p>
                </div>
              </td>
              <td>
                <div>{{ item.total|brlPrice }}</div>
                <div>
                  <small class="theme-account-history-type-icon">Valor: {{item.fare|brlPrice}}</small>
                </div>
                <div>
                  <small class="theme-account-history-type-icon">Impostos e taxas: {{ item.taxes|brlPrice }}</small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" style="padding:20px;">
        <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-10">
          <button
            class="btn btn-danger _tt-uc pull-right btn-block"
            v-on:click="cancelBooking(item)"
          >Solicitar Cancelamento</button>
        </div> -->

        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <button
            type="button"
            class="btn btn-primary _tt-uc pull-right btn-block"
            data-toggle="collapse"
            :data-target="'#collapse-' + item.id"
            aria-expanded="true"
            aria-controls="collapseTho"
          >+ Mais detalhes</button>
        </div>
      </div>
      <div :id="'collapse-' + item.id" class="collapse" aria-labelledby="headingTho">
        <div class="card-body">
          <div class="changes-travalers theme-account-history table-responsive">
            <div class="col-md-12 changes-travalers">
              <div class="row">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Itinerário</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>
                        <div class="col-md-9 mb-20">
                          <div class="theme-search-results-item-flight-details-schedule">
                            <ul class="theme-search-results-item-flight-details-schedule-list">
                              <li v-for="segment in segments" :key="segment.id">
                                <i
                                  class="fa fa-plane theme-search-results-item-flight-details-schedule-icon"
                                ></i>
                                <div class="theme-search-results-item-flight-details-schedule-dots"></div>
                                <p
                                  class="theme-search-results-item-flight-details-schedule-date"
                                >{{ segment.departure | shortDateToHuman }}</p>
                                <div class="theme-search-results-item-flight-details-schedule-time">
                                  <span
                                    class="theme-search-results-item-flight-details-schedule-time-item"
                                  >
                                    {{ segment.departure|dateToHour }}
                                    <!-- <span>{{ segment.departure|formatDate('A') }}</span> -->
                                  </span>
                                  <span
                                    class="theme-search-results-item-flight-details-schedule-time-separator"
                                  >&mdash;</span>
                                  <span
                                    class="theme-search-results-item-flight-details-schedule-time-item"
                                  >
                                    {{ segment.arrival|dateToHour }}
                                    <!-- <span>{{ segment.arrival|formatDate('A') }}</span> -->
                                  </span>
                                </div>
                                <p
                                  class="theme-search-results-item-flight-details-schedule-fly-time"
                                >{{ calcFlightDuration(segment.departure, segment.arrival) }}</p>
                                <div
                                  class="theme-search-results-item-flight-details-schedule-destination"
                                >
                                  <div
                                    class="theme-search-results-item-flight-details-schedule-destination-item"
                                  >
                                    <p
                                      class="theme-search-results-item-flight-details-schedule-destination-title"
                                    >
                                      <b>{{ segment.origin }}</b>
                                    </p>
                                    <p
                                      class="theme-search-results-item-flight-details-schedule-destination-city"
                                    >{{ segment.origin_city }}</p>
                                  </div>
                                  <div
                                    class="theme-search-results-item-flight-details-schedule-destination-separator"
                                  >
                                    <span>&rarr;</span>
                                  </div>
                                  <div
                                    class="theme-search-results-item-flight-details-schedule-destination-item"
                                  >
                                    <p
                                      class="theme-search-results-item-flight-details-schedule-destination-title"
                                    >
                                      <b>{{ segment.destination }}</b>
                                    </p>
                                    <p
                                      class="theme-search-results-item-flight-details-schedule-destination-city"
                                    >{{ segment.destination_city }}</p>
                                  </div>
                                </div>
                                <ul
                                  class="theme-search-results-item-flight-details-schedule-features"
                                >
                                  <li>{{ segment.airline.iata }}</li>
                                  <li>{{ segment.airline.name }}</li>
                                  <li>{{ segment.number }}</li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="modal fade"
              id="ModalTaxRules"
              tabindex="-1"
              role="dialog"
              aria-labelledby="ModalTaxRules"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content change-modal">
                  <div class="modal-header change-modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h3 class="modal-title text-center" id="ModalTaxRules">Regras tarifárias</h3>
                  </div>
                  <div class="modal-body content-change-modal">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                  </div>
                  <div class="modal-footer change-modal-footer">
                    <button
                      type="button"
                      class="btn _tt-uc btn-primary btn-lg btn-block"
                      data-dismiss="modal"
                    >Fechar</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Modal Regras tarifÃ¡rias -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shortDateToHuman } from '@/filters/datetime'
import moment from 'moment'

export default {
  filters: {
    shortDateToHuman
  },
  props: ["item", "fetchParent"],
  computed: {
    flight (){
      return this.item.flight;
    },
    traveler() {
      return this.item;
    },
    segments() {
      return this.item.flight.segments;
    },
    canCancel() {
      return _.contains([3], this.item.status);
    },
  },
  mounted () {
    $('.collapse').collapse({ toggle: false })
  },
  methods: {
    calcFlightDuration(departure, arrival) {
      return moment.duration(moment(arrival, 'YYYY-MM-DD HH:mm:ss').diff(moment(departure, 'YYYY-MM-DD HH:mm:ss'))).format('H[H]mm[M]')
    },
    getStatus(status) {
      let statuses = {
        1: "Processando",
        2: "Reservado",
        3: "Emitido",
        4: "Cancelado",
        6: "Pagamento Recusado",
        7: "Cancelado",
      };

      if (this.item.approval) {
        if (this.item.approval.status==1) {
          return 'Aguardando Aprovação';
        }
      }

      return statuses[status];
    },
    cancelBooking(item) {
      this.$swal({
        title: "Tem certeza que deseja cancelar essa reserva?",
        type: "question",
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if(result.value) {
          this.$parent.loading = true;
          this.$http({
            url: "/api/user/order/item/cancel",
            method: "POST",
            data: {
              orderitem_id: item.id
            }
          })
          .then((response) => {
            this.$parent.loading = false;
            this.$swal({
              title: response.data.message || "Pedido cancelado com sucesso!",
              type: "success",
              showConfirmButton: true
            }).then(() =>{
              this.fetchParent();
            });
            this.$ga.event({
              eventCategory: 'Flight',
              eventAction: 'Cancel',
              eventLabel: 'Canceled Flight',
              eventValue: 1
            })
          })
          .catch(() => {
            this.$parent.loading = false;
            this.$swal({
              title: "Não foi possível cancelar seu pedido, tente novamente",
              type: "error",
              showConfirmButton: true
            });
          });
        }
      })
    },
  }
};
</script>
